import React, { useState, useEffect } from 'react';
import { X, Info, AlertTriangle, CheckCircle } from 'lucide-react';
import api from '../services/api';

const AnnouncementBanner = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [dismissed, setDismissed] = useState([]);

  useEffect(() => {
    loadAnnouncements();
    // Load dismissed from localStorage
    const dismissedIds = JSON.parse(localStorage.getItem('dismissed_announcements') || '[]');
    setDismissed(dismissedIds);
  }, []);

  const loadAnnouncements = async () => {
    try {
      const response = await api.get('/announcements/active');
      setAnnouncements(response.data.announcements || []);
    } catch (error) {
      console.error('Failed to load announcements:', error);
    }
  };

  const handleDismiss = (announcementId) => {
    const newDismissed = [...dismissed, announcementId];
    setDismissed(newDismissed);
    localStorage.setItem('dismissed_announcements', JSON.stringify(newDismissed));
  };

  const getIcon = (type) => {
    switch (type) {
      case 'warning':
        return <AlertTriangle className="w-5 h-5" />;
      case 'success':
        return <CheckCircle className="w-5 h-5" />;
      default:
        return <Info className="w-5 h-5" />;
    }
  };

  const getStyles = (type) => {
    switch (type) {
      case 'warning':
        return 'bg-yellow-500/20 border-yellow-500/30 text-yellow-800 dark:text-yellow-200';
      case 'success':
        return 'bg-green-500/20 border-green-500/30 text-green-800 dark:text-green-200';
      default:
        return 'bg-blue-500/20 border-blue-500/30 text-blue-800 dark:text-blue-200';
    }
  };

  const visibleAnnouncements = announcements.filter(a => !dismissed.includes(a.id));

  if (visibleAnnouncements.length === 0) return null;

  return (
    <div className="space-y-2 mb-4" data-testid="announcement-banner">
      {visibleAnnouncements.map((announcement) => (
        <div
          key={announcement.id}
          className={`p-4 rounded-xl border ${getStyles(announcement.type)} flex items-start gap-3`}
        >
          <div className="flex-shrink-0 mt-0.5">
            {getIcon(announcement.type)}
          </div>
          <div className="flex-1">
            <h4 className="font-semibold">{announcement.title}</h4>
            <p className="text-sm opacity-90">{announcement.message}</p>
          </div>
          <button
            onClick={() => handleDismiss(announcement.id)}
            className="flex-shrink-0 p-1 hover:bg-black/10 dark:hover:bg-white/10 rounded-lg transition-colors"
            aria-label="Dismiss announcement"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default AnnouncementBanner;
